import { z } from 'zod';
export const ROLE_SLUGS = ['admin', 'member'];
export const RoleSlug = z.enum(ROLE_SLUGS);
export const TeamMember = z.object({
    id: z.string(),
    email: z.string(),
    displayName: z.string().nullable(),
    isAdmin: z.boolean(),
    powerDialerEnabled: z.boolean(),
    /** True once the user has signed in to the product (WorkOS id linked). */
    signedIn: z.boolean(),
});
export const TeamResponse = z.object({ members: z.array(TeamMember) });
export const InviteRequest = z.object({
    email: z.string().trim().toLowerCase().email(),
    role: RoleSlug.default('member'),
});
export const Invite = z.object({
    id: z.string(),
    email: z.string(),
    role: RoleSlug.nullable(),
    state: z.enum(['pending', 'accepted', 'expired', 'revoked']),
    expiresAt: z.string(),
});
export const InvitesResponse = z.object({ invites: z.array(Invite) });
export const UpdateTeamMemberRequest = z.object({ isAdmin: z.boolean() });
//# sourceMappingURL=team.js.map